import { PlatformDraft } from '../types/api';

/** Build API payload for platform_content from Redux drafts. */
export function platformDraftsToPayload(
  drafts: Record<string, PlatformDraft>
): Record<string, PlatformDraft> {
  return Object.fromEntries(
    Object.entries(drafts).map(([platform, draft]) => [
      platform,
      {
        platform: draft.platform,
        content: draft.content,
        char_count: draft.char_count,
        char_limit: draft.char_limit,
        within_limit: draft.within_limit,
      },
    ])
  );
}

/** Restore Redux platform drafts from a saved post. */
export function platformContentFromPost(
  platformContent?: Record<string, PlatformDraft>,
  fallbackContent?: string
): Record<string, PlatformDraft> {
  if (platformContent && Object.keys(platformContent).length > 0) {
    return platformContent;
  }
  if (fallbackContent) {
    return {
      linkedin: {
        platform: 'linkedin',
        content: fallbackContent,
        char_count: fallbackContent.length,
        char_limit: 3000,
        within_limit: fallbackContent.length <= 3000,
      },
    };
  }
  return {};
}
